<template>
  <v-dialog persistent v-model="dialog" max-width="50%">
    <template v-slot:activator="{ on, attrs }">
      <!-- <div class="d-flex flex-column"> -->
      <v-btn
        v-on="on"
        v-bind="attrs"
        color="primary"
        class="text-capitalize"
        block
      >
        <v-icon size="20" class="mx-2">mdi-bank</v-icon>
        Banking Information
      </v-btn>
      <!-- </div> -->
    </template>
    <v-card class="mx-auto">
      <v-card-title>
        Bank Payment Information
        <v-spacer />
        <v-btn color="red" text icon @click="dialog = !dialog">
          <v-icon>close</v-icon></v-btn
        >
      </v-card-title>
      <v-card-text class="pa-5">
        <v-row class="mx-5">
          <v-col cols="12" md="4" sm="12" class="text-caption text-uppercase">
            Bank Account Name:
          </v-col>
          <v-col cols="12" md="8" sm="12" class="text-caption text-uppercase">
            Kenya Institute of Supplies Examination Board
          </v-col>
        </v-row>

        <v-divider class="my-3"></v-divider>

        <v-row class="mx-5">
          <v-col cols="12" md="4" sm="12" class="text-caption text-uppercase">
            Bank Account:
          </v-col>
          <v-col cols="12" md="8" sm="12" class="text-caption text-uppercase">
            01020239943600
          </v-col>
        </v-row>
        <v-divider class="my-3"></v-divider>

        <v-row class="mx-5">
          <v-col cols="12" md="4" sm="12" class="text-caption text-uppercase">
            Bank Name:
          </v-col>
          <v-col cols="12" md="8" sm="12" class="text-caption text-uppercase">
            National Bank of Kenya Ltd
          </v-col>
        </v-row>
        <v-divider class="my-3"></v-divider>

        <v-row class="mx-5">
          <v-col cols="12" md="4" sm="12" class="text-caption text-uppercase">
            Branch:
          </v-col>
          <v-col cols="12" md="8" sm="12" class="text-caption text-uppercase">
            Ngong Road
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
import FileMixin from "../../../mixin/FileMixin";
export default {
  name: "PastPapers",
  mixins: [FileMixin],
  data() {
    return {
      dialog: false,
    };
  },
  computed: {
    pastPapers() {
      return [
        {
          name: "APS-K",
          color: "teal lighten-4",
          btncolor: "teal darken-4",
          link: `${process.env.VUE_APP_TEMP_URL}/storage/pastpapers/APS-pastpapers.rar`,
        },
        {
          name: "CPSP-K",
          color: "green lighten-4",
          btncolor: "green darken-4",
          link: `${process.env.VUE_APP_TEMP_URL}/storage/pastpapers/CPSPK-pastpapers.rar`,
        },
      ];
    },
  },
};
</script>
